import { assign, createMachine } from 'xstate';
import { Context, Events } from './types';

const filtersOptions = createMachine<Context, Events>({
  id: 'filtersOptions',
  predictableActionArguments: true,
  initial: 'idle',
  context: {
    products: [],
  },
  states: {
    idle: {
      on: {
        INITIALIZE: {
          target: 'loading',
        },
      },
    },
    success: {
      type: 'final',
    },
    error: {
      on: {
        INITIALIZE: {
          target: 'loading',
        },
      },
    },
    loading: {
      invoke: {
        src: 'getFiltersOptions',
        onDone: {
          target: 'success',
          actions: assign((_ctx, event) => {
            return {
              products: event.data.productNames,
            };
          }),
        },
        onError: {
          target: 'error',
        },
      },
    },
  },
});

export { filtersOptions };
